import DataLayer from "./DataLayer";

export default (promotions) => {
    DataLayer.track({
        event: "promotion_impression",
        ecommerce: {
            promoView: {
                promotions: promotions.map((promo) => ({
                    id: promo.id,
                    name: promo.name,
                    creative: promo.creative,
                    position: promo.position,
                })),
            },
        },
    });
};
